<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="closealert"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-truck"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Checked In Packages for Validation
              </div>
              <div
                v-if="verifcaitonmessage"
                class="warning--text display-2"
              >
                {{ verifcaitonmessage }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getcheckedpackages"
              :single-expand="singleExpand"
              :expanded.sync="expanded"
              show-expand
              :items-per-page="10"
              :search="search"
              sort-by="timestamp"
              sort-desc
              item-key="checkintime"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-card class="my-0">
                    <v-card-text>
                      <base-subheading
                        subheading="Shipments"
                      />
                      <v-data-table
                        :headers="headers_contents"
                        :items="item.contents"
                        item-key="key"
                        sort-by="timestamp"
                        sort-desc
                      >
                        <template v-slot:[`item.timestamp`]="{ item }">
                          {{ format_time(item.timestamp) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </td>
              </template>
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Shipments</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-btn
                    to="/PostalVerifyManagement"
                    color="warning"
                  >
                    return
                  </v-btn>
                  <v-dialog
                    v-model="dialogduplicate"
                    max-width="600px"
                  >
                    <v-card>
                      <v-card-title>
                        <span class="headline">Log Duplicate Contents</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row
                            v-for="(item,index) in getBags"
                            :key="index"
                          >
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            >
                              <v-text-field
                                v-model="item.securebagdeposit.BagNumber"
                                outlined
                                label="Bag Number"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="4"
                              md="3"
                            >
                              <v-btn
                                color="info"
                                @click="removeBag(index)"
                              >
                                Remove Item
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-col
                            cols="12"
                            sm="4"
                            md="3"
                          >
                            <v-btn
                              color="green"
                              @click="addBag"
                            >
                              <v-icon>mdi-plus</v-icon>
                              Add Bags
                            </v-btn>
                          </v-col>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closeduplicate"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="saveduplicate"
                        >
                          Save As Recieved
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <v-card>
                      <v-card-title>
                        <span class="headline">Validate Contents Only</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-data-table
                                v-model="selected"
                                :single-select="singleSelect"
                                show-select
                                :items="editedItem.contents"
                                item-key="timestamp"
                                :headers="headers_contents"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            />
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            />
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            />
                            <v-col
                              cols="12"
                              sm="6"
                              md="6"
                            />
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="save"
                        >
                          Save As Recieved
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.validated`]="{ item }">
                <div v-if="item.validated === false">
                  <v-icon
                    color="warning"
                  >
                    mdi-account-question
                  </v-icon>
                </div>
                <div v-if="item.validated === true">
                  <v-icon color="green">
                    mdi-account-check
                  </v-icon>
                </div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div v-if="item.duplicated">
                  <v-btn
                    small
                    class="mr-2"
                    color="orange white--text"
                    :disabled="item.validated"
                    @click="verifyDuplicate(item)"
                  >
                    Validate Duplicate
                  </v-btn>
                </div>
                <div v-if="!item.duplicated">
                  <v-btn
                    small
                    class="mr-2"
                    color="green white--text"
                    :disabled="item.validated"
                    @click="verifyItem(item)"
                  >
                    Validate Receipt
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.shipmentnum`]="{ item }">
                {{ item }}
              </template>
              <template v-slot:[`item.label`]="{ item }">
                <a
                  :href="getlabelpdfurl(item)"
                  target="_blank"
                >
                  <v-icon color="red">mdi-pdf-box</v-icon><v-icon>mdi-download</v-icon>
                </a>
              </template>
              <template v-slot:[`item.manifest`]="{ item }">
                <v-btn
                  outlined
                  small
                  color="deep-purple darken-1"
                  dark
                  @click="generatepdf(item)"
                >
                  <v-icon color="red">
                    mdi-pdf-box
                  </v-icon><v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>

              <template v-slot:[`item.amount`]="{ item }">
                {{ format_amt(item.securebagdeposit.DepositAmount) }}
              </template>
              <template v-slot:[`item.bagid`]="{ item }">
                {{ item.securebagdeposit.BagNumber }}
              </template>
              <template v-slot:[`item.trackingnumber`]="{ item }">
                {{ item.tracking_number }}
              </template>
              <template v-slot:[`item.duplicated`]="{ item }">
                <span v-if="item.duplicated">Duplicate</span>
                <span v-if="!item.duplicated">Original</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="primary"
                  @click="validateItem(item)"
                >
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                Sorry, No info {{ sitedetails.idnum }}
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns-tz'
  import { jsPDF } from 'jspdf'
  const axios = require('axios')
  var numeral = require('numeral')
  var jrQrcode = require('jr-qrcode')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      dialogduplicate: false,
      singleSelect: false,
      selected: [],
      dupbagselected: [ { securebagdeposit: { BagNumber: '' } } ],
      group: '',
      loading: false,
      sitedetails: '',
      snackbar: false,
      unit_id: '',
      timeout: 7000,
      search: '',
      alertmessage: '',
      baglist: [],
      expanded_bags: [],
      singleExpand: true,
      headers_contents: [
        { text: 'Created', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Bag', align: 'left', value: 'securebagdeposit.BagNumber', sortable: true },
        { text: 'Total Logged', align: 'left', value: 'securebagdeposit.DepositAmount', sortable: true },
      ],
      headers_bags: [
        { text: 'Created', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Bag', align: 'left', value: 'securebagdeposit.BagNumber', sortable: true },
        { text: 'Coin Logged', align: 'left', value: 'securebagdeposit.CoinAmount', sortable: true },
        { text: 'Cash Logged', align: 'left', value: 'securebagdeposit.CurrencyAmount', sortable: true },
        { text: 'Total Logged', align: 'left', value: 'securebagdeposit.DepositAmount', sortable: true },
      ],
      headers: [
        { text: 'Checked In', align: 'left', value: 'datecheckin', sortable: true },
        { text: 'Created', align: 'left', value: 'created_at', sortable: true },
        { text: 'Duplicate', align: 'left', value: 'duplicated', sortable: true },
        { text: 'Validated', align: 'left', value: 'validated', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'tracking_number', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        { text: 'Manifest', align: 'center', value: 'manifest', sortable: true },
        { text: 'Num Bags', align: 'center', value: 'numbags', sortable: true },
        { text: 'Validated Bags', align: 'center', value: 'validatedbags', sortable: true },
        { text: 'Validated Time UTC', align: 'center', value: 'validateddate', sortable: true },
      ],
      shipments: [],
      expanded: [],
      expanded_deposits: [],
      editedIndex: -1,
      editedItem: {
        consolidatedcash: {
          CurrencyAmount: 0,
          CoinAmount: 0,
          DepositAmount: 0,
        },
        verifiedcash: {
          CurrencyAmount: 0,
          CoinAmount: 0,
          DepositAmount: 0,
        },
        safeid: '',
        bags: [],
        idnum: '',
        timestamp: '',
        allowedusers: '',
        duration: '',
        washifyid: '',
        source: '',
        status: '',
        userid: '',
        amount: '',
      },
      defaultItem: {
        consolidatedcash: {
          CurrencyAmount: 0,
          CoinAmount: 0,
          DepositAmount: 0,
        },
        verifiedcash: {
          CurrencyAmount: 0,
          CoinAmount: 0,
          DepositAmount: 0,
        },
        safeid: '',
        idnum: '',
        bags: [],
        timestamp: '',
        duration: '',
        allowedusers: '',
        washifyid: '',
        status: '',
        userid: '',
        amount: '',
        source: '',
      },
    }),

    computed: {
      getBags () {
        return this.dupbagselected
      },
      getcheckedpackages () {
        console.log('packages checked ', this.$store.getters.getCheckedPackages)
        let packs = ''
        packs = this.$store.getters.getCheckedPackages
        packs.forEach(item => {
          let numbags = 'NA'
          let datecheckin = moment(item.checkintime).format('YYYY-MM-DD HH:mm:ss')
          Object.assign(item, { datecheckin: datecheckin })
          if (item.contents) {
            numbags = item.contents.length
          }
          Object.assign(item, { numbags: numbags })
        })
        this.shipments = packs
        return packs
      },
      verifcaitonmessage () {
        let message = ''
        let group = ''
        group = this.sitedetails.group
        if (group === 'The Body Shop') {
          message = 'Do Not Count this location! Please manifest and send to the Bank.\nPlease just mark as received'
        }
        return message
      },
      formIsValid () {
        return this.editedItem.email !== '' &&
          this.editedItem.accesscode !== '' &&
          this.editedItem.username !== ''
      },
      formTitle () {
        let title = 'Verify Package'
        if (this.editedIndex === -1) {
          title = 'New Shipment'
        }
        return title
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogduplicate (val) {
        val || this.closeduplicate()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },

    created () {
      // this.$store.dispatch('loadcheckedinpackages')
      this.$store.dispatch('loadcheckedinpackages_v2')
    },
    beforeDestroy () {
    },
    methods: {
      addBag () {
        let bagRec = {
          securebagdeposit: {
            BagNumber: ''
          },
        }
        this.dupbagselected.push(bagRec)
      },
      removeBag (value) {
        if (value > 0) {
          this.dupbagselected = this.dupbagselected.filter((item, index) => index !== value)
        }
      },
      closealert () {
        this.snackbar = false
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('MMMM Do, h:mm:ss')
      },
      initialize () {
      },

      // these are bags which are already part of this specific shipment
      getbagsofshipment (contents) {
        let bags = []
        if (contents) {
          contents.forEach(entry => {
            let details = { BagNumber: entry.securebagdeposit.BagNumber, DepositAmount: entry.securebagdeposit.DepositAmount }
            bags.push(details)
          })
        }

        return bags
      },

      verifyItem (item) {
        this.editedIndex = this.shipments.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        console.log('verify item index ', this.editedIndex)
        this.$log.debug('this is an edit')
      },
      verifyDuplicate (item) {
        this.editedIndex = this.shipments.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogduplicate = true
        this.$log.debug('this is an edit of a dupe')
      },
      closeduplicate () {
        this.dialogduplicate = false
        this.selected = []
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      close () {
        this.dialog = false
        this.selected = []
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      saveduplicate () {
        if (this.editedIndex > -1) {
          this.editedItem.verifiedstatus = true
          console.log('verify this duplicate ', this.editedItem, this.dupbagselected)
          this.selected = []
          let validationRec = {
            selected: this.dupbagselected,
            item: this.editedItem
          }
          this.$store.dispatch('validateShipmentContents', validationRec)
          this.dupbagselected = []
        } else {
          this.shipments.push(this.editedItem)
          // this.editedItem.verifiedstatus = true
          // do nothing here, dont mess up our records
          // this.$store.dispatch('createrelease', this.editedItem)
        }
        console.log('I should reload shipment data')
        // this.$store.dispatch('loadreleases')
        // this.$store.dispatch('loadcheckedinpackages')
        this.$store.dispatch('loadcheckedinpackages_v2')

        this.closeduplicate()
      },
      save () {
        console.log('edited index ', this.editedIndex)
        if (this.editedIndex > -1) {
          this.editedItem.verifiedstatus = true
          console.log('verify this ', this.editedItem, this.selected)
          let validationRec = {
            selected: this.selected,
            item: this.editedItem
          }
          console.log('passing validation rec ', validationRec)
          this.$store.dispatch('validateShipmentContents', validationRec)
          this.selected = []
        } else {
          this.shipments.push(this.editedItem)
          // this.editedItem.verifiedstatus = true
          // do nothing here, dont mess up our records
          // this.$store.dispatch('createrelease', this.editedItem)
        }
        console.log('I should reload shipment data')
        // this.$store.dispatch('loadreleases')
        // this.$store.dispatch('loadcheckedinpackages')
        this.$store.dispatch('loadcheckedinpackages_v2')

        this.close()
      },
    },
  }
</script>
